// extracted by mini-css-extract-plugin
module.exports = {"roundButton":"clinical-portal-3__RoundButton__roundButton"};